<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.users") }}</h4>
            </div>
            <div class="card-body px-3">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
              <div class="table-responsive1 mt-2">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search"
                    :placeholder="$t('message.search')"
                  />
                  <button
                    v-if="search !== ''"
                    class="btn btn-link"
                    style="
                      position: absolute;
                      top: 0;
                      right: 40px;
                      height: 100%;
                    "
                    @click="searchFuncClear"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentcolor"
                      height="14px"
                      viewBox="0 0 384 512"
                    >
                      <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                      />
                    </svg>
                  </button>
                  <button
                    class="btn btn-link"
                    style="position: absolute; top: 0; right: 0; height: 100%"
                    @click="searchFunc"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentcolor"
                      height="14px"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                      />
                    </svg>
                  </button>
                </div>
                <!-- :options="field_filter_options(field.key)" @hit="setFilter(field.key, $event)" @clear-selection="clearFilter(field.key)"/> -->
                <template v-for="admin in users_admins">
                  <div class="card mb-3">
                    <div
                      v-b-toggle="'users' + admin.org_code"
                      class="card-header"
                    >
                      <div class="row" style="font-size: 14px">
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>E-mail</small>
                          </div>
                          {{ admin.email }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>ФИО</small>
                          </div>
                          {{ admin.given_name }}
                          {{ admin.middle_name }}
                          {{ admin.last_name }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>Страна</small>
                          </div>
                          {{ admin.country }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>Наименование</small>
                          </div>
                          {{ admin.org_name }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>ИНН</small>
                          </div>
                          {{ admin.org_code }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>Баланс</small>
                          </div>
                          {{ rubFormat(admin.balance) }}
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>Телефон</small>
                          </div>
                          {{ admin.admin_phone }}
                        </div>
                        <div class="col-md-2">
                          <div class="text-muted text-small">
                            <small>Дата регистрации</small>
                          </div>
                          {{ admin.reg_date }}
                        </div>
                        <div class="col-md-2">
                          <div class="text-muted text-small">
                            <small>Привилегия</small>
                          </div>
                          <button
                            class="btn btn-sm"
                            :class="
                              admin.is_privileged
                                ? 'btn-success'
                                : 'btn-secondary'
                            "
                            @click.prevent.stop="togglePriviledge(admin)"
                          >
                            <span v-if="admin.is_privileged">Отключить</span>
                            <span v-else>Включить</span>
                          </button>
                        </div>
                        <div class="col-md-4">
                          <div class="text-muted text-small">
                            <small>Действия</small>
                          </div>
                          <div class="btn-group">
                            <button
                              class="btn btn-sm btn-info"
                              v-if="admin.active == 1"
                              @click.prevent.stop="
                                topupUserAccount(admin.user_id)
                              "
                            >
                              {{ $t("message.account.topup_account") }}
                            </button>
                            <button
                              class="btn btn-sm btn-danger"
                              v-if="admin.active == 1"
                              @click.prevent.stop="lock_user(admin.user_id)"
                            >
                              <!-- {{$t('message.admin.lock_user')}} -->
                              Заблокировать
                            </button>
                            <button
                              class="btn btn-sm btn-success"
                              v-if="admin.active == 0"
                              @click.prevent.stop="un_lock_user(admin.user_id)"
                            >
                              <!-- {{$t('message.admin.unlock_user')}} -->
                              Разблокировать
                            </button>
                          </div>
                          <span class="ml-2 when-open"
                            ><i class="fas fa-chevron-up"></i
                          ></span>
                          <span class="ml-2 when-closed"
                            ><i class="fas fa-chevron-down"></i
                          ></span>
                        </div>
                        <!-- <div class="align-items-center col-md-1 d-flex justify-content-end pl-0">
                                                
                                            </div> -->
                      </div>
                    </div>
                    <b-collapse :id="'users' + admin.org_code">
                      <div class="card-body">
                        <div class="table-responsive">
                          <b-table
                            :items="admin.children"
                            :fields="user_fields"
                            :sort-compare="mySortCompare"
                            :tbody-tr-class="rowClass"
                          >
                            <template v-slot:cell(full_name)="data">
                              <router-link
                                target="_blank"
                                :to="{
                                  name: 'user-profile-personal',
                                  params: { id: data.item.org_code },
                                }"
                              >
                                {{ data.item.given_name }}
                                {{ data.item.middle_name }}
                                {{ data.item.last_name }}
                              </router-link>
                            </template>
                            <template v-slot:cell(org_name)="data">
                              <router-link
                                target="_blank"
                                :to="{
                                  name: 'user-profile-company',
                                  params: { id: data.item.org_code },
                                }"
                              >
                                {{ data.item.org_name }}
                              </router-link>
                            </template>
                            <template v-slot:cell(balance)="data">
                              {{ rubFormat(data.value) }}
                            </template>
                            <template v-slot:cell(is_privileged)="data">
                              <button
                                class="btn btn-sm"
                                :class="
                                  data.item.is_privileged
                                    ? 'btn-success'
                                    : 'btn-secondary'
                                "
                                @click.prevent="togglePriviledge(data.item)"
                              >
                                <span v-if="data.item.is_privileged"
                                  >Отключить</span
                                >
                                <span v-else>Включить</span>
                              </button>
                            </template>
                            <template v-slot:cell(number)="data">
                              {{ data.item.email }}
                            </template>
                            <template v-slot:cell(active)="data">
                              <div class="btn-group">
                                <!-- <button class="btn btn-sm btn-info" v-if="data.item.active==1" @click="topupUserAccount(data.item.user_id)">{{$t('message.account.topup_account')}}</button> -->
                                <button
                                  class="btn btn-sm btn-danger"
                                  v-if="data.item.active == 1"
                                  @click="lock_user(data.item.user_id)"
                                >
                                  <!-- {{$t('message.admin.lock_user')}} -->
                                  Заблокировать
                                </button>
                                <button
                                  class="btn btn-sm btn-success"
                                  v-if="data.item.active == 0"
                                  @click="un_lock_user(data.item.user_id)"
                                >
                                  <!-- {{$t('message.admin.unlock_user')}} -->
                                  Разблокировать
                                </button>
                              </div>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </template>

                <!-- <b-table :items="users" :fields="user_fields" :per-page="per_page" :current-page="current_page">
                                    <template v-slot:cell(full_name)="data">
                                        <router-link target=_blank :to="{name: 'user-profile-personal', params: {id: data.item.org_code}}">
                                            {{data.item.given_name}}
                                            {{data.item.middle_name}}
                                            {{data.item.last_name}}
                                        </router-link>
                                    </template>
                                    <template v-slot:cell(org_name)="data">
                                        <router-link target=_blank :to="{name: 'user-profile-company', params: {id: data.item.org_code}}">
                                            {{data.item.org_name}}
                                        </router-link>
                                    </template>
                                    <template v-slot:cell(balance)="data">
                                        {{rubFormat(data.value)}}
                                    </template>
                                    <template v-slot:cell(is_privileged)="data">
                                        <button class="btn btn-sm" :class="data.item.is_privileged?'btn-success':'btn-secondary'" @click.prevent="togglePriviledge(data.item)">
                                            <span v-if="data.item.is_privileged">Отключить</span>
                                            <span v-else>Включить</span>
                                        </button>
                                    </template>
                                    <template v-slot:cell(number)="data">
                                        {{data.item.email}}
                                    </template>
                                    <template v-slot:cell(active)="data">
                                        <div class="btn-group">
                                        <button class="btn btn-sm btn-info" v-if="data.item.active==1" @click="topupUserAccount(data.item.user_id)">{{$t('message.account.topup_account')}}</button>
                                        <button class="btn btn-sm btn-danger" v-if="data.item.active==1" @click="lock_user(data.item.user_id)">{{$t('message.admin.lock_user')}}</button>
                                        <button class="btn btn-sm btn-success" v-if="data.item.active==0" @click="un_lock_user(data.item.user_id)">{{$t('message.admin.unlock_user')}}</button>
                                    </div>
                                    </template>
                                </b-table> -->
              </div>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="users_length"
                  :per-page="per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
              <!-- <div class="d-flex justify-content-center">
                                <b-pagination
                                    v-model="current_page"
                                    :total-rows="users_length"
                                    :per-page="per_page"
                                    aria-controls="my-table"
                                ></b-pagination>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-topup-funds"
      :hide-footer="true"
      size="sm"
      :title="$t('message.account.topup_account')"
      button-size="lg"
    >
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.account.topup_amount") }}
        </label>
        <!-- <input type="number" v-model="topup_amount" class="form-control"> -->
        <div class="rub-input">
          <cleave
            v-model="topup_amount"
            :options="cleave_money"
            class="border border-light form-control-sm shadow-sm"
            autocomplete="off"
            style="cursor: auto"
            id="amount"
          ></cleave>
        </div>
      </div>
      <div class="text-center">
        <button @click="confirm_topup()" class="btn btn-success btn-sm">
          {{ $t("message.add") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import dodelTypeahead from "../fields/dodel-typeahead.vue";
export default {
  name: "admin-users",
  components: {
    dodelTypeahead,
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    users_admins() {
      return this.users;
    },
    // users_length(){
    //     return this.users.length
    // }
  },
  data() {
    return {
      search: "",
      users_length: 0,
      cleave_money: {
        numeral: true,
        numeralDecimalMark: ",",
        delimiter: " ",
      },
      current_page: 1,
      per_page: 100,
      users: [],
      topup_amount: 0,
      topup_user: -1,
      user_fields: [
        {
          key: "number",
          label: "E-mail", //this.$t('message.contracts.documents_packaging_number'),
          sortable: true,
        },
        // {
        //     key: 'is_privileged',
        // 	label: this.$t('message.account.is_privileged'),
        // 	sortable: true
        // },
        {
          key: "full_name",
          label: this.$t("message.account.org_founders_person_name"),
          sortable: true,
        },
        {
          key: "org_name",
          label: this.$t("message.account.org_founders_company"),
          sortable: true,
        },
        // {
        //     key: 'org_code',
        // 	label: this.$t('message.account.iin'),
        // 	sortable: true
        // },
        // {
        //     key: 'balance',
        // 	label: this.$t('message.account.balance'),
        // 	sortable: true
        // },
        {
          key: "country",
          label: this.$t("message.account.org_founders_country"),
          sortable: true,
        },
        {
          key: "reg_date",
          label: this.$t("message.contracts.ap_main_reg_date"),
          sortable: true,
        },
        {
          key: "active",
          label: this.$t("message.admin.active"),
          sortable: true,
        },
      ],
    };
  },
  watch: {
    current_page() {
      if (this.search !== "") this.load(this.search);
      else this.load();
    },
  },
  methods: {
    searchFuncClear() {
      this.current_page = 1;
      this.search = "";
      this.load();
    },
    searchFunc() {
      this.current_page = 1;
      this.load(this.search);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_email_verified === 1) return "table-success";
      if (item.is_email_verified === 0) return "table-warning";
      if (item.is_email_verified === -1) return "table-danger";
    },
    mySortCompare(a, b, key) {
      if (key === "reg_date") {
        // Assuming the date field is a `Date` object, subtraction
        // works on the date serial number (epoch value)
        return (
          moment(b[key], "DD.MM.YYYY H:m:s").unix() -
          moment(a[key], "DD.MM.YYYY H:m:s").unix()
        );
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false;
      }
    },
    rubFormat(amount) {
      return window.rubFormat(amount);
    },
    togglePriviledge(data) {
      axios
        .post(window.base + "/account/setPrivilege", {
          id: data.user_id,
          is_privileged: !data.is_privileged,
        })
        .then(() => {
          this.load();
        });
    },
    /**
     * send request to add funds to user account
     */
    confirm_topup() {
      let fd = new FormData();
      fd.append("user_id", this.topup_user);
      fd.append("amount", this.topup_amount);
      axios
        .post(window.base + "/account/TopUp", fd)
        .then((response) => {
          this.load();
          this.$bvModal.hide("modal-topup-funds");
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          this.$bvModal.hide("modal-topup-funds");
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
    /**
     * Shows modal to add funds to user's account
     * @param {*} user_id
     */
    topupUserAccount(user_id) {
      this.topup_user = user_id;
      this.$bvModal.show("modal-topup-funds");
    },
    /**
     * Fetches list of all users, filters only those who is not active and
     * adds to users list
     */
    load(search = false) {
      let url =
        window.base +
        "/account/GetUsers?page=" +
        (this.current_page - 1) +
        "&pageSize=" +
        this.per_page;
      if (search !== false) {
        url =
          window.base +
          "/account/GetUsers?page=" +
          (this.current_page - 1) +
          "&pageSize=" +
          this.per_page +
          "&iin=" +
          this.search +
          "&name=" +
          this.search + 
          "&user_name=" +
          this.search;
      }
      axios.get(url).then(async (response) => {
        // this.users = response.data//.filter(i=>i.active==1)
        this.users = {};
        // console.log(response.data.filter(item=>item.is_admin))
        // response.data.forEach(item=>{
        //     if(item.is_admin===true){
        //         if(this.users[item.org_code] !== undefined){
        //             this.users[item.org_code].children.push(item)
        //         }else{
        //             this.users[item.org_code] = {item: {}, children: []}
        //             this.users[item.org_code].children.push(item)
        //         }
        //     }else{
        //         if(this.users[item.org_code] !== undefined){
        //             this.users[item.org_code].item = item
        //         }else{
        //             this.users[item.org_code] = {item, children: []}
        //         }
        //     }
        // })
        //pick all admins
        this.users_length = response.data[0].total_count;
        await response.data
          .filter((item) => item.is_admin === true)
          .forEach((item) => {
            this.users[item.org_code] = {
              ...item,
              children: response.data.filter(
                (child) =>
                  child.is_admin == false && child.org_code == item.org_code,
              ),
            };
          });

        this.users = Object.values(this.users).sort((a, b) => {
          return (
            moment(b.reg_date, "DD.MM.YYYY H:m:s").unix() -
            moment(a.reg_date, "DD.MM.YYYY H:m:s").unix()
          );
        });

        // //pick all non-admins
        // setTimeout(()=>{
        // response.data.filter(item=>item.is_admin===false).forEach(item=>{
        //     console.log(item)
        //     this.users[item.org_code].children.push(item)
        // })
        // }, 2000)

        // response.data.forEach(item=>{
        //     if(item.is_admin){
        //         let user = {...item, children: []}
        //         console.log(user)
        //         this.users[item.org_code] = user
        //     }else{
        //         this.users[item.org_code].children.push(item)
        //     }
        // })
      });
    },
    /**
     * @params user_id – user identifier
     * accepts user_id as a param and sends request to the backend to
     * un_lock user registration
     */
    un_lock_user(user_id) {
      var fd = new FormData();
      fd.append("user_id", user_id);
      axios
        .post(window.base + "/account/UnlockUser", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
    /**
     * @params user_id – user identifier
     * accepts user_id as a param and sends request to the backend to
     * lock user registration
     */
    lock_user(user_id) {
      var fd = new FormData();
      fd.append("user_id", user_id);
      axios
        .post(window.base + "/account/LockUser", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
  },
};
</script>
<style>
.page-item.active button {
  /* background: #9c27b0 !important; */
  /* color: #fff !important; */
}
.collapsed > .row > .col-md-4 > .when-open,
.row > .col-md-4 > .when-closed {
  display: none;
}
.collapsed > .row > .col-md-4 > .when-closed {
  display: inline-block;
}
</style>
